"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'email.payment.success.subject': 'Payment Successful - Subscription Confirmed',
    'email.payment.success.title': 'Payment Processed Successfully!',
    'email.payment.success.text': 'Thank you for your payment. Your subscription has been confirmed and is now active.',
    'email.payment.success.confirmation': 'You will receive a receipt for this payment shortly.',
    'email.payment.success.footer': 'If you have any questions, please contact our support team.',
    'email.payment.failed.subject': 'Payment Failed - Action Required',
    'email.payment.failed.title': 'Payment Processing Failed',
    'email.payment.failed.text': 'We were unable to process your payment for your subscription. Please update your payment method to continue using our services.',
    'email.payment.failed.retry_text': 'To avoid service interruption, please retry your payment as soon as possible.',
    'email.payment.failed.retry_button': 'Retry Payment',
    'email.payment.failed.support_button': 'Contact Support',
    'email.payment.failed.footer': 'If you continue to experience issues, please contact our support team for assistance.',
    'email.payment.plan': 'Subscription Plan',
    'email.payment.amount': 'Amount',
    'email.payment.next_billing': 'Next Billing Date',
    'email.payment.failure_reason': 'Failure Reason',
    'email.payment.dashboard_button': 'View Dashboard',
    'email.payment.download_invoice': 'Download Invoice',
};
